"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useParticipatingActivities = void 0;
var client_1 = require("@apollo/client");
var PARTICIPATING_ACTIVITIES_QUERY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query {\n    allEvents {\n      id path slug url name __typename\n      startDate\n      endDate\n      badge\n      isReadable\n      openGraph { id image { id url } }\n    }\n    listTeams(filter: { types: { in: [\"collaboration\"] } } ) {\n      results {\n        id path slug name slug __typename\n        status { id name }\n        typeLabel\n        isReadable\n        openGraph { id image { id url } }\n      }\n    }\n    allPrograms {\n      id path name slug __typename \n      openGraph { id image { id url } }\n      isReadable\n      courses {\n        id path name slug __typename\n        startDate\n        endDate\n        openGraph { id image { id url } }\n      }\n    }\n  }\n"], ["\n  query {\n    allEvents {\n      id path slug url name __typename\n      startDate\n      endDate\n      badge\n      isReadable\n      openGraph { id image { id url } }\n    }\n    listTeams(filter: { types: { in: [\"collaboration\"] } } ) {\n      results {\n        id path slug name slug __typename\n        status { id name }\n        typeLabel\n        isReadable\n        openGraph { id image { id url } }\n      }\n    }\n    allPrograms {\n      id path name slug __typename \n      openGraph { id image { id url } }\n      isReadable\n      courses {\n        id path name slug __typename\n        startDate\n        endDate\n        openGraph { id image { id url } }\n      }\n    }\n  }\n"])));
var useParticipatingActivities = function () {
  var _a;
  var _b = (0, client_1.useQuery)(PARTICIPATING_ACTIVITIES_QUERY),
    queryData = _b.data,
    loading = _b.loading;
  var data = {
    allPrograms: (queryData === null || queryData === void 0 ? void 0 : queryData.allPrograms) || [],
    allEvents: (queryData === null || queryData === void 0 ? void 0 : queryData.allEvents) || [],
    allTeams: ((_a = queryData === null || queryData === void 0 ? void 0 : queryData.listTeams) === null || _a === void 0 ? void 0 : _a.results) || []
  };
  return {
    loading: loading,
    data: data
  };
};
exports.useParticipatingActivities = useParticipatingActivities;
var templateObject_1;